import { USER_CONSTANTS } from "../../constants/user";

export const getRoleName = (role: string | undefined) => {
  if(!role) {
    return '';
  }

  return USER_CONSTANTS.find(el => el.id === role)?.label;
};
